import VuePlupload from './src/components/vue-plupload.vue'

export default {
    install(Vue) {
        Vue.component('vue-plupload', VuePlupload)
    }
}